// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.note[data-v-c6ffeed0] {\n  margin-bottom: 16px;\n}\n.note-content[data-v-c6ffeed0] {\n  white-space: pre-wrap;\n}\n", ""]);
// Exports
module.exports = exports;
